(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/statistics-common/assets/external-match-id.js') >= 0) return;  svs.modules.push('/components/sport/statistics-common/assets/external-match-id.js');
"use strict";

const _svs$components$sport = svs.components.sport.statisticsCommon,
  logger = _svs$components$sport.logger,
  useExternalMatchIds = _svs$components$sport.useExternalMatchIds;

const ExternalMatchId = _ref => {
  let branding = _ref.branding,
    matchId = _ref.matchId,
    productId = _ref.productId,
    type = _ref.type,
    children = _ref.children,
    FallbackComp = _ref.FallbackComp;
  const _useExternalMatchIds = useExternalMatchIds(matchId, productId),
    loading = _useExternalMatchIds.loading,
    rejected = _useExternalMatchIds.rejected,
    externalId = _useExternalMatchIds.externalId;
  if (loading) {
    return children(undefined, loading);
  } else if (rejected) {
    return 'Något gick fel';
  } else if (!externalId[type]) {
    logger.info("Missing external match id for match: ".concat(matchId, " type: ").concat(type));
    if (FallbackComp) {
      return React.createElement(FallbackComp, {
        branding: branding
      }, "Inget att visa");
    }
    return null;
  }
  return children(externalId[type]);
};
setGlobal('svs.components.sport.statisticsCommon.ExternalMatchId', ExternalMatchId);

 })(window);